export default {

  'ADD_TO_CART_TEXT': {
    'default': 'Add to Cart on',
    'french': 'Ajouter au panier sur'
  },

  'CURRENCY_CHARACTERS': {
    'default': {
      'preceeding': '$',
      'following': ''
    },
    'french': {
      'preceeding': '',
      'following': '&euro;'
    },
    'united_kingdom': {
      'preceeding': '&pound;',
      'following': ''
    }
  },

  'MORE_INFO_TEXT': {
    'default': 'More Info',
    'french': 'Plus d\'info'
  },

  'CURRENT_PRODUCT_FROM_TEXT': {
    'default': 'from',
    'french': 'de'
  },

  'ADDED_TO_CART_TEXT': {
    'default': '1 item added to cart',
    'french': '1 produit ajouté au panier'
  },

  'KEEP_SHOPPING_TEXT': {
    'default': 'Keep Shopping',
    'french': 'Continuez vos achats'
  },

  'SHOP_THE_LOOK_TEXT': {
    'default': 'Shop the look'
  },

  'COMPLETE_YOUR_PURCHASE_TEXT': {
    'default': 'Complete your purchase on',
    'french': 'Terminer vos achats sur'
  },

  'CHECKOUT_NOW_TEXT': {
    'default': 'Checkout Now',
    'french': 'Acheter maintenant'
  },

  'FORM_IS_SUBMITTING': {
    'default': 'Checking out now'
  },

  'SHOP_NOW_TEXT': {
    'default': 'Shop Now',
    'french': 'Acheter maintenant'
  },

  'POWERED_BY_TEXT': {
    'default': 'powered by',
    'french': 'Réaliser par'
  },

  'COLOR_OPTION_TEXT': {
    'default': 'option',
    'french': 'couleur'
  },

  'SIZE_OPTION_TEXT': {
    'default': 'option',
    'french': 'taille'
  },

  'PLEASE_SELECT_TEXT': {
    'default': 'Please select',
    'french': 'Sélectionnez votre'
  },

  'SELECTED_TEXT': {
    'default': 'selected',
    'french': 'validée'
  },

  'SELECT_ABOVE_TEXT': {
    'default': 'above',
    'french': '&nbsp;'
  }

}



// WEBPACK FOOTER //
// ./client/store/constants.js